
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.25 21.75a.75.75 0 01-.75-.75h-.75a.75.75 0 010-1.5h2.031a.589.589 0 00.543-.824.584.584 0 00-.323-.317l-2.063-.826a2.083 2.083 0 01-1.312-1.94c0-.559.217-1.084.612-1.48a2.079 2.079 0 011.262-.603v-.01a.75.75 0 011.5 0h.75a.75.75 0 010 1.5h-2.033a.593.593 0 00-.22 1.142l2.063.826a2.094 2.094 0 011.161 2.722A2.08 2.08 0 0118 20.99V21a.75.75 0 01-.75.75z"}}),_c('path',{attrs:{"d":"M17.25 24c-3.722 0-6.75-3.028-6.75-6.75s3.028-6.75 6.75-6.75S24 13.528 24 17.25 20.972 24 17.25 24zm0-12C14.355 12 12 14.355 12 17.25s2.355 5.25 5.25 5.25 5.25-2.355 5.25-5.25S20.145 12 17.25 12z"}}),_c('path',{attrs:{"d":"M2.25 16.5A2.252 2.252 0 010 14.25v-12A2.252 2.252 0 012.25 0h16.5A2.252 2.252 0 0121 2.25v6a.75.75 0 01-1.5 0V6h-18v8.25c0 .414.336.75.75.75h6a.75.75 0 010 1.5h-6zm17.25-12V2.25a.75.75 0 00-.75-.75H2.25a.75.75 0 00-.75.75V4.5h18z"}}),_c('path',{attrs:{"d":"M3.75 9.75a.75.75 0 010-1.5h6a.75.75 0 010 1.5h-6zM3.75 12.75a.75.75 0 010-1.5h3a.75.75 0 010 1.5h-3z"}})])
          )
        }
      }
    